"use strict";

var alt                   = require("../alt");
var AuthenticationActions = require("../actions/AuthenticationActions");
var CompanyActions = require("../actions/CompanyActions");
var networking = require("../utils/Networking.js");
var Networking = new networking();
var _ = require("underscore");

var NotificationActions = require('../actions/NotificationActions');

class AuthenticationStore {
    constructor() {
        this.bindActions(AuthenticationActions);

        this.token = "";
        this.error = "";
        this.loading = false;
        this.login_error = false;
        this.signup_error = false;

        this.id = "";
        this.access = {};
        this.last_login = "";
        this.is_superuser = false;
        this.username = "";
        this.first_name = "";
        this.last_name = "";
        this.email = "";
        this.is_staff = false;
        this.is_active = true;
        this.date_joined = "";
        this.account = "";
        this.groups = [];
        this.user_permissions = [];
        this.departments = [];
        this.roles = [];
        this.home_department = "";
    }

    onClearNotifications() {
        var clearNotification = {
            "type": "",
            "message": "",
            "isActive": false,
            "color": "",
            "dismissAfter": 0
        };
        this.setState({notification: clearNotification});
    }

    onGetUserInfo() {
        var success = function(result) {
            this.setState(result);
            localStorage.setItem('userId', result.id);
        }.bind(this);
        var failure = function(error) {
            console.error("=== AuthStore getUserInfo() fail ===", error)
            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Tókst ekki að sækja upplýsingar um notanda",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.GET("user/", success, failure);
    }

    onUpdateUserInfo(data) {

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: "Upplýsingum um notanda hefur verið breytt",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onGetUserInfo();
        }.bind(this);
        var failure = function(error) {
            console.error("=== AuthStore updateUserInfo() fail ===", error)
            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Ekki tókst að breyta upplýsingum notanda",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.PUT("user/"+data.id+"/", data.body, success, failure);
    }

    onCheckLoggedIn() {
        var token = localStorage.getItem("token");

        // this.setState({token: token});

        if (token) {
            // Get the user's info from the server.
            this.onGetUserInfo();

            // We defer calling this function because it requires
            // a new dispatch, which is not possible during our
            // current dispatch.
            _.defer(CompanyActions.getCompanyData);
        }

    }

    onLoginUser(data) {
        this.setState({ loading: true });

        var success = function(result) {
            localStorage.setItem('token', result.token);
            var newState = {};
            newState.token = result.token;
            newState.loading = false;
            newState.login_error = false;
            newState.signup_error = false;
            this.setState(newState);
        }.bind(this);
        var failure = function(error) {
            console.error("=== AuthStore loginUser() fail ===", error)
            this.setState({token:"", loading: false, login_error: true, signup_error: false });
        }.bind(this);

        Networking.POST("api-token-auth/", data, success, failure);
    }

    onLogoutUser() {
        // Do stuff
        localStorage.removeItem("token");
        this.setState({
            token: "",
            error: "",
            id: "",
            access: {},
            last_login: "",
            is_superuser: false,
            username: "",
            first_name: "",
            last_name: "",
            email: "",
            is_staff: false,
            is_active: true,
            date_joined: "",
            account: "",
            groups: [],
            user_permissions: [],
            departments: [],
            roles: [],
            home_department: ""
        })
    }

    onSignUp(data) {
      this.setState({ loading: true });

      var success = function(result) {
          this.setState({loading: false, signup_error: false, login_error: false});
      }.bind(this);

      var failure = function(error) {
          console.error("=== AuthStore signUp() fail ===", error)
          this.setState({loading: false, signup_error: true, login_error: false});
      }.bind(this);

      Networking.POST("selfsignup/", data, success, failure);

    }
}

var authenticationStore = alt.createStore(AuthenticationStore, "AuthenticationStore");

window.authenticationStore = authenticationStore;

module.exports = authenticationStore;



// WEBPACK FOOTER //
// ./app/scripts/stores/AuthenticationStore.js